module.exports = __webpack_public_path__ + "img/career-history.bec16c41.svg";